import type { AspidaClient } from 'aspida';
import { dataToURLString } from 'aspida';
import type { Methods as Methods_1rfrvw2 } from './entry/add';
import type { Methods as Methods_1bihvd5 } from './entry/check';
import type { Methods as Methods_1836yx } from './entry/subscribe';
import type { Methods as Methods_1l1jvkb } from './follow/add';
import type { Methods as Methods_1yl6bc0 } from './follow/check';
import type { Methods as Methods_1xu2gn3 } from './follow/unlink';
import type { Methods as Methods_10h1you } from './group/category';
import type { Methods as Methods_1h1j3sy } from './group/get';
import type { Methods as Methods_wzjhpu } from './group/list';
import type { Methods as Methods_ovd46t } from './shop/get';
import type { Methods as Methods_zzjbwj } from './shop/list';

const api = <T>({ baseURL, fetch }: AspidaClient<T>) => {
  const prefix = (baseURL === undefined ? '' : baseURL).replace(/\/$/, '');
  const PATH0 = '/entry/add';
  const PATH1 = '/entry/check';
  const PATH2 = '/entry/subscribe';
  const PATH3 = '/follow/add';
  const PATH4 = '/follow/check';
  const PATH5 = '/follow/unlink';
  const PATH6 = '/group/category';
  const PATH7 = '/group/get';
  const PATH8 = '/group/list';
  const PATH9 = '/shop/get';
  const PATH10 = '/shop/list';
  const GET = 'GET';

  return {
    entry: {
      add: {
        get: (option: { query: Methods_1rfrvw2['get']['query'], config?: T | undefined }) =>
          fetch<Methods_1rfrvw2['get']['resBody']>(prefix, PATH0, GET, option).json(),
        $get: (option: { query: Methods_1rfrvw2['get']['query'], config?: T | undefined }) =>
          fetch<Methods_1rfrvw2['get']['resBody']>(prefix, PATH0, GET, option).json().then(r => r.body),
        $path: (option?: { method?: 'get' | undefined; query: Methods_1rfrvw2['get']['query'] } | undefined) =>
          `${prefix}${PATH0}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
      },
      check: {
        get: (option: { query: Methods_1bihvd5['get']['query'], config?: T | undefined }) =>
          fetch<Methods_1bihvd5['get']['resBody']>(prefix, PATH1, GET, option).json(),
        $get: (option: { query: Methods_1bihvd5['get']['query'], config?: T | undefined }) =>
          fetch<Methods_1bihvd5['get']['resBody']>(prefix, PATH1, GET, option).json().then(r => r.body),
        $path: (option?: { method?: 'get' | undefined; query: Methods_1bihvd5['get']['query'] } | undefined) =>
          `${prefix}${PATH1}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
      },
      subscribe: {
        get: (option: { query: Methods_1836yx['get']['query'], config?: T | undefined }) =>
          fetch<Methods_1836yx['get']['resBody']>(prefix, PATH2, GET, option).json(),
        $get: (option: { query: Methods_1836yx['get']['query'], config?: T | undefined }) =>
          fetch<Methods_1836yx['get']['resBody']>(prefix, PATH2, GET, option).json().then(r => r.body),
        $path: (option?: { method?: 'get' | undefined; query: Methods_1836yx['get']['query'] } | undefined) =>
          `${prefix}${PATH2}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
      },
    },
    follow: {
      add: {
        get: (option: { query: Methods_1l1jvkb['get']['query'], config?: T | undefined }) =>
          fetch<Methods_1l1jvkb['get']['resBody']>(prefix, PATH3, GET, option).json(),
        $get: (option: { query: Methods_1l1jvkb['get']['query'], config?: T | undefined }) =>
          fetch<Methods_1l1jvkb['get']['resBody']>(prefix, PATH3, GET, option).json().then(r => r.body),
        $path: (option?: { method?: 'get' | undefined; query: Methods_1l1jvkb['get']['query'] } | undefined) =>
          `${prefix}${PATH3}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
      },
      check: {
        get: (option: { query: Methods_1yl6bc0['get']['query'], config?: T | undefined }) =>
          fetch<Methods_1yl6bc0['get']['resBody']>(prefix, PATH4, GET, option).json(),
        $get: (option: { query: Methods_1yl6bc0['get']['query'], config?: T | undefined }) =>
          fetch<Methods_1yl6bc0['get']['resBody']>(prefix, PATH4, GET, option).json().then(r => r.body),
        $path: (option?: { method?: 'get' | undefined; query: Methods_1yl6bc0['get']['query'] } | undefined) =>
          `${prefix}${PATH4}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
      },
      unlink: {
        get: (option: { query: Methods_1xu2gn3['get']['query'], config?: T | undefined }) =>
          fetch<Methods_1xu2gn3['get']['resBody']>(prefix, PATH5, GET, option).json(),
        $get: (option: { query: Methods_1xu2gn3['get']['query'], config?: T | undefined }) =>
          fetch<Methods_1xu2gn3['get']['resBody']>(prefix, PATH5, GET, option).json().then(r => r.body),
        $path: (option?: { method?: 'get' | undefined; query: Methods_1xu2gn3['get']['query'] } | undefined) =>
          `${prefix}${PATH5}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
      },
    },
    group: {
      category: {
        get: (option: { query: Methods_10h1you['get']['query'], config?: T | undefined }) =>
          fetch<Methods_10h1you['get']['resBody']>(prefix, PATH6, GET, option).json(),
        $get: (option: { query: Methods_10h1you['get']['query'], config?: T | undefined }) =>
          fetch<Methods_10h1you['get']['resBody']>(prefix, PATH6, GET, option).json().then(r => r.body),
        $path: (option?: { method?: 'get' | undefined; query: Methods_10h1you['get']['query'] } | undefined) =>
          `${prefix}${PATH6}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
      },
      get: {
        get: (option: { query: Methods_1h1j3sy['get']['query'], config?: T | undefined }) =>
          fetch<Methods_1h1j3sy['get']['resBody']>(prefix, PATH7, GET, option).json(),
        $get: (option: { query: Methods_1h1j3sy['get']['query'], config?: T | undefined }) =>
          fetch<Methods_1h1j3sy['get']['resBody']>(prefix, PATH7, GET, option).json().then(r => r.body),
        $path: (option?: { method?: 'get' | undefined; query: Methods_1h1j3sy['get']['query'] } | undefined) =>
          `${prefix}${PATH7}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
      },
      list: {
        get: (option?: { config?: T | undefined } | undefined) =>
          fetch<Methods_wzjhpu['get']['resBody']>(prefix, PATH8, GET, option).json(),
        $get: (option?: { config?: T | undefined } | undefined) =>
          fetch<Methods_wzjhpu['get']['resBody']>(prefix, PATH8, GET, option).json().then(r => r.body),
        $path: () => `${prefix}${PATH8}`,
      },
    },
    shop: {
      get: {
        get: (option: { query: Methods_ovd46t['get']['query'], config?: T | undefined }) =>
          fetch<Methods_ovd46t['get']['resBody']>(prefix, PATH9, GET, option).json(),
        $get: (option: { query: Methods_ovd46t['get']['query'], config?: T | undefined }) =>
          fetch<Methods_ovd46t['get']['resBody']>(prefix, PATH9, GET, option).json().then(r => r.body),
        $path: (option?: { method?: 'get' | undefined; query: Methods_ovd46t['get']['query'] } | undefined) =>
          `${prefix}${PATH9}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
      },
      list: {
        get: (option: { query: Methods_zzjbwj['get']['query'], config?: T | undefined }) =>
          fetch<Methods_zzjbwj['get']['resBody']>(prefix, PATH10, GET, option).json(),
        $get: (option: { query: Methods_zzjbwj['get']['query'], config?: T | undefined }) =>
          fetch<Methods_zzjbwj['get']['resBody']>(prefix, PATH10, GET, option).json().then(r => r.body),
        $path: (option?: { method?: 'get' | undefined; query: Methods_zzjbwj['get']['query'] } | undefined) =>
          `${prefix}${PATH10}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
      },
    },
  };
};

export type ApiInstance = ReturnType<typeof api>;
export default api;
